const locationLink = (latitude, longitude) => "https://www.google.com/maps/search/?api=1&query=".concat(latitude, ",").concat(longitude);
export default locationLink;